import { render, staticRenderFns } from "./VRangeSliderZoom.vue?vue&type=template&id=21522377&scoped=true&"
import script from "./VRangeSliderZoom.vue?vue&type=script&lang=ts&"
export * from "./VRangeSliderZoom.vue?vue&type=script&lang=ts&"
import style0 from "./VRangeSliderZoom.vue?vue&type=style&index=0&id=21522377&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21522377",
  null
  
)

export default component.exports